import React, { useState } from 'react';
import { Row, Col } from 'react-bootstrap';

import { useSnackbar } from 'v3/components/Snackbar';
import Text from 'v3/components/Text';
import { cooperplaceApi } from 'services/api';

import { useVehicleBodies } from '../shared/context';
import { Section } from '../shared/Section';
import { OwnerData as Inputs } from '../shared/Owner';

import { Editable } from '../shared/Editable';
import { validate } from '../shared/validator';

export function OwnerData() {
  const vehicleBody = useVehicleBodies();
  const snackbar = useSnackbar();
  const [editing, setEditing] = useState(false);
  const [loading, setLoading] = useState(false);

  async function saveData() {
    setLoading(true);
    const isDataValid = await validate(
      'owner',
      {
        owner: vehicleBody.data?.owner,
        beneficiary: vehicleBody.data?.beneficiary,
      },
      vehicleBody.setErrors
    );

    if (!isDataValid) {
      snackbar.show(<Text>Verifique os campos obrigatórios</Text>, {
        type: 'error',
      });
      setLoading(false);
      return;
    }

    try {

      const payload = {
        idOwner: vehicleBody?.data?.owner?.id,
        beneficiaryId: vehicleBody?.data?.beneficiary?.id,
      };

      await cooperplaceApi.put(`vehicleBodies/${vehicleBody.data.id}`, payload);

      vehicleBody.updatePrevVehicleBody(vehicleBody.data);

      snackbar.show(<Text>Atualizado com sucesso</Text>, { type: 'success' });

    } catch (error) {
      const message = error?.response?.data?.message || 'Erro ao atualizar';
      vehicleBody.setData(vehicleBody.prevVehicleBody);
      snackbar.show(<Text>{message}</Text>, { type: 'error' });
    } finally {
      setEditing(false);
      setLoading(false);
    }
  }

  return (
    <Section
      Title="Proprietário"
      HeaderRightComponent={
        <Editable
          isEditing={editing}
          setEditing={setEditing}
          onSave={saveData}
          isLoading={loading}
        />
      }
      loading={vehicleBody.loading}
    >
      {editing ? (
        <Inputs />
      ) : (
        <Row>
          <Col xs={12}>
            <Text type="label" color="#464E5F">
              Proprietário do documento
            </Text>
            <Text type="regular" color="gray" as="p" className="mt-2">
              {vehicleBody.data?.owner?.socialName ||
                vehicleBody.data?.owner?.social_name ||
                'Não informado'}
              {vehicleBody?.data?.owner?.cpfCnpj || vehicleBody?.data?.owner?.cgccpf
                ? ` - ${vehicleBody?.data?.owner?.cpfCnpj ||
                vehicleBody?.data?.owner?.cgccpf
                }`
                : ''}
            </Text>
          </Col>
          <Col xs={12}>
            <Text type="label" color="#464E5F">
              Beneficiário do implemento
            </Text>
            <Text type="regular" color="gray" as="p" className="mt-2">
              {vehicleBody.data?.beneficiary?.socialName ||
                vehicleBody.data?.beneficiary?.social_name ||
                'Não informado'}
              {vehicleBody?.data?.beneficiary?.cpfCnpj || vehicleBody?.data?.beneficiary?.cgccpf
                ? ` - ${vehicleBody?.data?.beneficiary?.cpfCnpj ||
                vehicleBody?.data?.beneficiary?.cgccpf
                }`
                : ''}
            </Text>
          </Col>
        </Row>
      )}
    </Section>
  );
}
